(ns client-portal.client.day-part-schedules.data
  (:require [client-portal.client.concepts.data :as concepts.d]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def root-path [:day-part-schedules])
(def by-concept-id-path (conj root-path :by-concept-id))
(def list-path (conj root-path :list))

(defn concept-day-parts
  [day-parts]
  (filter #(nil? (:location-id %)) day-parts))

(defn location-day-parts
  [day-parts location-id]
  (filter #(= (:location-id %) location-id) day-parts))

(defn current-day-parts [db]
  (or (when-let [concept-id (concepts.d/current-concept-id db)]
        (get-in db (conj by-concept-id-path concept-id)))
      (get-in db list-path)))

(re/reg-auth0-loader
  :day-parts/load-day-part-schedules
  (fn [[concept-id]]
    (conj by-concept-id-path concept-id))
  (fn [_ concept-id]
    {:method :get
     :url "/api/day-part-schedules"
     :query-params {:concept-id concept-id}})
  :transf (fn [resp] (or (some-> resp :body (util/->kebab-case-keywords))
                         []))
  :error-transf (fn [] []))

(re/reg-event-db
  :day-parts/set-list re/middleware
  (fn [db [day-parts]]
    (assoc-in db list-path day-parts)))

(re/reg-sub
  :day-parts/list-
  (fn [db]
    (get-in db list-path)))

(re/reg-sub
  :day-parts/by-current-concept-id-
  (fn [db]
    (let [concept-id (concepts.d/current-concept-id db)
          v (current-day-parts db)]
      (if (and concept-id (nil? v))
        (re/dispatch-load [:day-parts/load-day-part-schedules concept-id])
        v))))
